import { render, staticRenderFns } from "./DynamicInputsSubmit.vue?vue&type=template&id=94965d4c&"
import script from "./DynamicInputsSubmit.vue?vue&type=script&lang=js&"
export * from "./DynamicInputsSubmit.vue?vue&type=script&lang=js&"
import style0 from "./DynamicInputsSubmit.vue?vue&type=style&index=0&id=94965d4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports